import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '~/routes/components/AuthProvider';
import { FAT_PROTEIN_SLUG, MILK_FIXED_SLUG, MILK_MONEY_ACCOUNT_SLUG, MILK_STOCK_EXCHANGE } from '~/Constants';
import NotificationCard from './NotificationCard';
import { StyledNotificationCardGroup } from './style';

const tradingSlotSlugs = [MILK_FIXED_SLUG, MILK_STOCK_EXCHANGE, FAT_PROTEIN_SLUG];

const Notifications: React.FC = () => {
  const { systemData: { modules } } = useAuth();
  const { t } = useTranslation();

  const hasAnyTradingSlot = Boolean(
    modules.find(module => !!tradingSlotSlugs.find(slug => slug === module.slug))
  );
  const hasMilkMoney = modules.find(module => module.slug === MILK_MONEY_ACCOUNT_SLUG);

  function renderTradingSlotsNotifications() {
    return <>
      <NotificationCard
        icon='bell'
        title={t('New trading slot')}
        description={t('Get notified the moment a new trading slot becomes available.')}
        emailKey='newTradingSlotEmails'
        requiredKey='newTradingSlotEmailStatus'
      />
      <NotificationCard
        icon='chart bar'
        title={t('Daily summary')}
        description={t('A daily recap of trading activity, totals and key metrics.')}
        emailKey='summaryEmails'
        requiredKey='summaryEmailStatus'
      />
      <NotificationCard
        icon='clock outline'
        title={t('Trading slot completion')}
        description={t('Alerts sent when a trading slot is fully completed.')}
        emailKey='completedSummaryEmails'
        requiredKey='completedSummaryStatus'
      />
    </>
  }

  return (
    <StyledNotificationCardGroup itemsPerRow={2} stackable>
      {hasAnyTradingSlot && renderTradingSlotsNotifications()}
      {hasMilkMoney && (
        <>
          <NotificationCard
            icon='warning sign'
            title={t('Tour import errors')}
            description={t('Receive a report whenever a tour import fails or has issues.')}
            emailKey='toursImportErrorEmails'
            requiredKey='toursImportErrorStatus'
          />
          <NotificationCard
            icon='calendar times outline'
            title={t('Farmer last delivery date exceeded?')}
            description={t('Alerts when a farmer\'s last delivery date has been exceeded.')}
            emailKey='lastDeliveryDateDeactivatedEmails'
            requiredKey='lastDeliveryDateDeactivatedEmailStatus'
          />
        </>
      )}
    </StyledNotificationCardGroup>
  );
};

export default Notifications;
